import type { ResourceConfig } from "../types";

export const groupScoreConfig = {
  displayName: "小组积分",
  category: "group-score",
  permissions: {
    "write:all": {
      label: "管理小组积分",
      description: "可以手动加分、编辑和删除小组积分记录",
    },
  },
} satisfies ResourceConfig;
